/**
 * 数值转换相关工具
 * - 提供统一的「将任意值转换为可排序数字」的方法
 */

/**
 * 将任意值转换为可排序的数值
 * 无效值（空字符串、null、undefined、NaN）统一映射为 Number.NEGATIVE_INFINITY，
 * 便于在排序时自然落到末尾。
 */
export const convertToSortableValue = (
  value: unknown,
): { numeric: number; isValid: boolean; } => {
  if (value === '' || value === null || value === undefined) {
    return { numeric: Number.NEGATIVE_INFINITY, isValid: false };
  }
  const numeric = Number(value);
  if (Number.isNaN(numeric)) {
    return { numeric: Number.NEGATIVE_INFINITY, isValid: false };
  }
  return { numeric, isValid: true };
};


